import { DocInfo } from "@services/api";
import DocCard from "./DocCard";
import { FileSyncOutlined, SafetyCertificateTwoTone } from "@ant-design/icons";

interface Props {
  docs?: DocInfo[];
  className?: string;
}

const DOC_BG_SCAN: string = "bg_guaranteeScan";
const DOC_BG_DRAFT: string = "bg_guaranteeDraft";

export default function DocBgCard({ docs, className }: Props) {
  const hasBgScan: boolean = docs?.some((d) => d.docType === DOC_BG_SCAN && !!d.files?.length) || false;

  if (hasBgScan) {
    return (
      <DocCard
        title="Гарантия выпущена"
        docType={DOC_BG_SCAN}
        docs={docs}
        className={className}
        icon={<SafetyCertificateTwoTone twoToneColor="#52c41a" style={{ fontSize: 64 }} />}
      />
    );
  }

  const hasBgDraft: boolean = docs?.some((d) => d.docType === DOC_BG_DRAFT && !!d.files?.length) || false;
  if (!hasBgDraft) return null;

  return (
    <>
      <DocCard
        title="Макет гарантии"
        docType={DOC_BG_DRAFT}
        docs={docs}
        className={className}
        icon={<FileSyncOutlined style={{ color: "#1677ff", fontSize: 64 }} />}
      />
    </>
  );
}
